import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { SeguimientoService } from '../../../services/formulacion/seguimiento.service';
import { switchMap } from 'rxjs/operators';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { OperacionService, GeneralService } from '../../../services/service.index';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxComponent, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
declare var jQuery: any;
declare var toastr;

@Component({
  selector: 'app-mes-activo',
  templateUrl: './mes-activo.component.html',
  styles: []
})
export class MesActivoComponent implements OnInit {

  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  @ViewChild(DxSelectBoxComponent) selectBox: DxSelectBoxComponent
  mesActual: string = '';
  baseUrl = environment.apiEndpoint;
  meses: any = [];
  dias: any = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }, { id: 7 }, { id: 8 }, { id: 9 }, { id: 10 }, { id: 11 }, { id: 12 }, { id: 13 }, { id: 14 }, { id: 15 }, { id: 16 }, { id: 17 }, { id: 18 }, { id: 19 }, { id: 20 }, { id: 21 }, { id: 22 }, { id: 23 }, { id: 24 }, { id: 25 }, { id: 26 }, { id: 27 }, { id: 28 }, { id: 29 }, { id: 30 }, { id: 31 }];
  mesesLiteral = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
  d = new Date();
  gestion: string;
  hasError: any;
  popupActualizar: boolean = false;
  gestiones: any = [];

  model: any = { id: 0, dia: 0, mes: '', gestion_id: 0, gestion: '', dia_id: 0, mes_id: 0 };
  constructor(private _ss: SeguimientoService, private _gs: GeneralService) {
    this.gestion = JSON.parse(localStorage.getItem('g'));
    this.getGestiones();
    this.getMesAreportar();
    this.getDiaAreportar();
    this.mesActual = this.mesesLiteral[this.d.getMonth()];



  }

  ngOnInit() {
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  showModalPopPup() {
    this.popupActualizar = true;    
    this.getListaMeses();
    this.getGestiones();
    this.getMesAreportar();
    this.getDiaAreportar();
    this.resetErrors();    
  }

  getListaMeses() {
    this._ss.getListaMeses().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.meses = result.data;          
        }
        else { this.meses = []; }
      },
      (error) => { console.log('Error', error); });
  }

  resetErrors() {
    this.hasError = { mes_id: false, dia_id: false, gestion_id: false };
  }

  getGestionElegido(e: any) {
    if (e.value != undefined && e.value != null) {
      this.model.gestion_id = e.value
    }
  }
  getMesElegido(e: any) {
    if (e.value != undefined && e.value != null) {
      this.model.mes_id = e.value
    }
  }

  getDiaElegido(e: any) {
    if (e.value != undefined && e.value != null) {
      this.model.dia_id = e.value
    }
  }

  getMesAreportar() {
    this._ss.getMesDeReporte().subscribe(
      (Response) => {
        let result = UtilHelper.responses(Response);
        if (result.status == 200) {          
          this.model.mes = result.data.mes;          
          this.model.mes_id = result.data.id;
          this.model.gestion_id = parseInt(result.data.gestion_id);
          this.gestiones.forEach(item => {
            if (item.id == this.model.gestion_id) {
              this.model.gestion = item.descripcion.substring(0,4);
            }

          });
          
        }
      }
    );
  }

  getDiaAreportar() {
    this._ss.getDiaDeReporte().subscribe(
      (Response) => {
        let result = UtilHelper.responses(Response);
        if (result.status == 200) {
          this.model.dia = result.data.sigla;
          this.model.dia_id =  parseInt(result.data.sigla);          
        }
      }
    );
  }

  saveMesDia() {
    if (this.validSave()) {
      this._ss.putMesDia(this.model).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.popupActualizar = false;
            this.getMesAreportar();
            this.getDiaAreportar();
            toastr.success('Datos actualizados exitosamente.');
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  validSave() {
    let res = true;
    if (!UtilHelper.validator(this.model.gestion_id, 0)) {
      this.hasError.gestion_id = true; res = false;
    }
    if (!UtilHelper.validator(this.model.mes_id, 0)) {
      this.hasError.mes_id = true; res = false;
    }

    if (!UtilHelper.validator(this.model.dia_id, 0)) {
      this.hasError.dia_id = true; res = false;
    }

    return res;
  }

  getGestiones() {
    this._gs.getGestionesCombo().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.gestiones = result.data;
        }
        else { this.gestiones = []; }
      },
      (error) => { console.log('Error', error); });
  }

}
